/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiFileFileIdDelete } from '../fn/file-upload/api-file-file-id-delete';
import { ApiFileFileIdDelete$Params } from '../fn/file-upload/api-file-file-id-delete';
import { apiFileMasterclassUrlPost } from '../fn/file-upload/api-file-masterclass-url-post';
import { ApiFileMasterclassUrlPost$Params } from '../fn/file-upload/api-file-masterclass-url-post';
import { apiFileUrlFileIdGet } from '../fn/file-upload/api-file-url-file-id-get';
import { ApiFileUrlFileIdGet$Params } from '../fn/file-upload/api-file-url-file-id-get';
import { FileUrl } from '../models/file-url';


/**
 * File service
 */
@Injectable({ providedIn: 'root' })
export class FileUploadService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFileUrlFileIdGet()` */
  static readonly ApiFileUrlFileIdGetPath = '/api/file/url/{file_id}';

  /**
   * Get an Alfresco URL.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileUrlFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileUrlFileIdGet$Response(params: ApiFileUrlFileIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
    return apiFileUrlFileIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an Alfresco URL.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileUrlFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileUrlFileIdGet(params: ApiFileUrlFileIdGet$Params, context?: HttpContext): Observable<FileUrl> {
    return this.apiFileUrlFileIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileUrl>): FileUrl => r.body)
    );
  }

  /** Path part for operation `apiFileFileIdDelete()` */
  static readonly ApiFileFileIdDeletePath = '/api/file/{file_id}';

  /**
   * Delete an uploaded file in AWS S3 and remove it from the database.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileFileIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileFileIdDelete$Response(params: ApiFileFileIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
    return apiFileFileIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an uploaded file in AWS S3 and remove it from the database.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileFileIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileFileIdDelete(params: ApiFileFileIdDelete$Params, context?: HttpContext): Observable<FileUrl> {
    return this.apiFileFileIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileUrl>): FileUrl => r.body)
    );
  }

  /** Path part for operation `apiFileMasterclassUrlPost()` */
  static readonly ApiFileMasterclassUrlPostPath = '/api/file/masterclass-url';

  /**
   * Get an AWS S3 URL.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileMasterclassUrlPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiFileMasterclassUrlPost$Response(params: ApiFileMasterclassUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
    return apiFileMasterclassUrlPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an AWS S3 URL.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileMasterclassUrlPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiFileMasterclassUrlPost(params: ApiFileMasterclassUrlPost$Params, context?: HttpContext): Observable<FileUrl> {
    return this.apiFileMasterclassUrlPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileUrl>): FileUrl => r.body)
    );
  }

}
